module.exports = __webpack_public_path__ + "images/emoji/abc.c09eee35f48493ca9d39.png";